import { render, staticRenderFns } from "./RegistrationCompleteDialog.vue?vue&type=template&id=3715e6fd&scoped=true&"
import script from "./RegistrationCompleteDialog.vue?vue&type=script&lang=js&"
export * from "./RegistrationCompleteDialog.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationCompleteDialog.vue?vue&type=style&index=0&id=3715e6fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3715e6fd",
  null
  
)

export default component.exports